import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const NewSearchWidgetAsyncComponent = AsyncComponent(async () => import('./new-search-widget' /* webpackChunkName: "template-widget" */ ));

export const NewSearchWidgetAsync = (props) => {
  return <React.Suspense fallback={<div/>}><NewSearchWidgetAsyncComponent {...props}/></React.Suspense>
}
